import axios from "axios";
import React, { memo, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { styled } from "styled-components";
import Comment from "./Comment";
import UserAvatar from "./UserAvatar";
import Button from "./atoms/Button";

const Container = styled.div``;
const NewComment = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
const Input = styled.input`
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colorOnSurfaceVariant};
  color: ${({ theme }) => theme.colorOnBackground};
  background-color: transparent;
  outline: none;
  padding: 5px;
  width: 100%;
`;

const Comments = memo(function ({ currentVideo }) {
  const path = useLocation().pathname.split("/")[2];

  const currentUser = useSelector((state) => state.user.currentUser);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const loadComments = useCallback(async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/comments/video/${path}`,
      );
      setComments(res.data);
    } catch (err) {}
  }, [path]);
  useEffect(() => {
    loadComments();
  }, [path, loadComments]);

  const handleComment = async (e) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_RECIPE_API_BASE_URL}/comments`,
        {
          desc: newComment,
          videoId: currentVideo._id,
        },
        { withCredentials: true },
      );
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_RECIPE_API_BASE_URL}/comments/video/${path}`,
        );
        setComments(res.data);
      } catch (err) {}
      setNewComment("");
    } catch (err) {
      if (!err.response) {
        console.log("Error: Network Error");
      } else {
        console.log(err.response.data.message);
      }
    }
  };

  return (
    <Container>
      <NewComment>
        <UserAvatar
          src={currentUser?.img}
          name={currentUser?.name}
          contrastColor={currentUser?.contrastColor}
          size={36}
        />
        <Input
          placeholder="Write a comment..."
          onChange={(e) => setNewComment(e.target.value)}
          value={newComment}
        />
        {currentUser ? (
          <Button
            variant="ghost"
            size="md"
            label="Comment"
            onClick={handleComment}
          />
        ) : (
          <Link
            to="/signin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <Button variant="ghost" size="sm" label="Comment" />
          </Link>
        )}
      </NewComment>
      {comments.map((comment) => (
        <Comment key={comment._id} comment={comment} />
      ))}
    </Container>
  );
});
export default Comments;
